import React from "react";
import { AccountContext, Account } from "../common/context/AccountContext";
import { useLiveData } from "../common/utils";
import { isSchoolUser, isSchoolUserStudent } from "../common/api";
import { Redirect } from "react-router-dom";

export function NonSchoolUserRoute({ children }) {
  const { accountLiveData } = React.useContext(AccountContext);
  const [userIsSchoolUser, setUserIsSchoolUser] = React.useState<boolean>();

  useLiveData(
    React.useCallback((account: Account) => {
      if (account.hasUserAndMaybeProfile()) {
        setUserIsSchoolUser(isSchoolUser(account.user!!));
      }
    }, []),
    accountLiveData
  );

  if (userIsSchoolUser === undefined) {
    return <></>
  }
  if (userIsSchoolUser) {
    return <Redirect to={"/"} />;
  }
  return children;
}

export function NonSchoolStudentUserRoute({ children }) {
  const { accountLiveData } = React.useContext(AccountContext);
  const [userIsSchoolStudentUser, setUserIsSchoolStudentUser] = React.useState<boolean>();

  useLiveData(
    React.useCallback((account: Account) => {
      if (account.hasUserAndMaybeProfile()) {
        setUserIsSchoolStudentUser(isSchoolUserStudent(account.user!!));
      }
    }, []),
    accountLiveData
  );

  if (userIsSchoolStudentUser === undefined) {
    return <></>
  }
  if (userIsSchoolStudentUser) {
    return <Redirect to={"/"} />;
  }
  return children;
}